const white = Number.parseInt('ffffff', 16);
const black = Number.parseInt('000000', 16);
export function isHexColor(color: string) {
    if (color.length !== 7) return false;
    if (!color.startsWith('#')) return false;
    const cur = Number.parseInt(color.substring(1), 16);
    return cur <= white && cur >= black;
}
